"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderList = void 0;
var React = require("react");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var sok_ui_1 = require("@caddigital/sok-ui");
var ListHeader_1 = require("../../components/ListHeader");
var ListRow_1 = require("../../components/ListRow");
var list_1 = require("utils/list");
var FolderList = function (props) {
    return (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
        var width = _a.width, height = _a.height;
        return (React.createElement(sok_ui_1.List, { header: React.createElement(ListHeader_1.ListHeader, __assign({}, props.headerData)), itemCount: props.listData.items.length, itemData: props.listData, itemWidth: props.contentWidth + 30, itemHeight: list_1.ROW_PIXEL_HEIGHT, width: width, height: height }, ListRow_1.ListRow));
    }));
};
exports.FolderList = FolderList;
